import { authDelete } from "@api";

import { SCMConfig } from "@pages/settings/types";

export const deleteSCMConfig = (
  parentOrgId: number,
  scmId: number
): Promise<SCMConfig> => {
  const path = `/api/agent/organizations/${parentOrgId}/scm_configs/${scmId}`;
  return authDelete<SCMConfig>(path);
};
